
<kendo-formfield>
    <kendo-label [text]="caption | translate"></kendo-label>
    <kendo-textbox 
    [ngClass]="{'fx-fill': settings.fxFill}"  
    [formControl]="control"
    [readonly]="settings.readonly"
    [maxlength]="settings.maxLength"
    (valueChange)="onChange($event)"
    > </kendo-textbox>
</kendo-formfield>
